import React, { Component } from 'react'
import PropTypes from 'prop-types'


import Icon from 'app/widgets/Icon'
import SelectionContext from '../../context'

import './style.scss'

class PreviewTools extends Component {
  static contextType = SelectionContext

  constructor(props, context) {
    super(props, context)
    this.myRef = React.createRef()
    this.setZoom = this.setZoom.bind(this)
  }

  setZoom(e) {
    this.props.zoomTo(e.scale)
  }

  render() {
    const pic = this.context.getPictureData(this.context.highlightedPictureId)
    const canSwap = this.props.canSwap
    const classNames = [
      'sel__picture-preview__tools',
      canSwap ? 'can-swap' : '',
      this.props.isProtected ? 'blur-protection-active' : ''
    ].filter(Boolean).join(' ')

    return (
      <section className={classNames} ref={this.myRef}>
        {canSwap && ([
          <button className="arrows prev" onClick={this.props.prev} key="goprev">
            <Icon.ArrowLeft />
          </button>,
          <button className="arrows next" onClick={this.props.next} key="gonext">
            <Icon.ArrowRight />
          </button>
        ])}

        <section className="info">
          <span>{pic.title}</span>
        </section>
      </section>
    )
  }
}

PreviewTools.propTypes = {
  collection: PropTypes.any,
  canSwap: PropTypes.bool,
  isProtected: PropTypes.bool,
  prev: PropTypes.func,
  next: PropTypes.func,
  zoomTo: PropTypes.func
}

export default PreviewTools
